import { render } from "./fieldTag.vue?vue&type=template&id=3809755e"
import script from "./fieldTag.vue?vue&type=script&lang=js"
export * from "./fieldTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__